export default __webpack_public_path__ + "static/media/success-transaction.ac7a4887.svg";